"use strict";

exports.__esModule = true;
exports.NewLogbookComment = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactIntl = require("react-intl");
var _icons = require("@blueprintjs/icons");
var _core = require("@blueprintjs/core");
var _Core = require("../../Core");
var _Theme = require("../../Theme");
var _NewLogbookCommentForm = require("./NewLogbookCommentForm");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var NewEventHeader = _styledComponents["default"].div.withConfig({
  displayName: "NewLogbookComment__NewEventHeader",
  componentId: "sc-w3ex6-0"
})(["background:", ";display:flex;justify-content:space-between;align-items:center;padding:0 0.8rem;height:48px;"], (0, _Theme.val)("LogBookNewEventBackground"));
var NewEventHeading = (0, _styledComponents["default"])(_Core.Heading).withConfig({
  displayName: "NewLogbookComment__NewEventHeading",
  componentId: "sc-w3ex6-1"
})(["padding:0;margin:0;"]);
var NewEventForm = _styledComponents["default"].div.withConfig({
  displayName: "NewLogbookComment__NewEventForm",
  componentId: "sc-w3ex6-2"
})(["padding:0.8rem;"]);
var NewLogbookComment = exports.NewLogbookComment = function NewLogbookComment(_ref) {
  var logbook = _ref.logbook;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(NewEventHeader, {
    "data-testid": "NewLogbookComment"
  }, /*#__PURE__*/_react["default"].createElement(NewEventHeading, {
    level: "4"
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "LogbookPanel.createCommentTitle",
    defaultMessage: "Create new comment"
  })), /*#__PURE__*/_react["default"].createElement(_core.Button, {
    minimal: true,
    icon: _icons.IconNames.CROSS
  })), /*#__PURE__*/_react["default"].createElement(NewEventForm, null, /*#__PURE__*/_react["default"].createElement(_NewLogbookCommentForm.NewLogbookCommentForm, {
    device: logbook.device
  })));
};